import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useEntitiesList from "../../utils/listHookNew";
import { DataTable } from "primereact/datatable";
import { DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import { useAuth0 } from "../../auth/react-auth0-wrapper"
import classNames from 'classnames';
import { deleteSim } from "../../api/simcards";
import Can from "../../auth/Can";
import roles from "../../auth/roles";

export default function DeviceList({ opt }) {
  let dtable;

  const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("simcards", "createdat desc", undefined, "");

  const { domains } = useAuth0();

  const [openModal, setOpenModal] = React.useState(false);
  const toggle = () => setOpenModal(!openModal);

  const onDelete = async id => {
    const value = await deleteSim(id);
    toggle();
    forceRefresh();
    return value;
  };

  const modalSection = () => (
    <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
      <ModalHeader toggle={toggle}>
        Eliminazione SIM
      </ModalHeader>
      <ModalBody>
        <p>Confermi di voler eliminare la SIM con ICCID {openModal.iccid}?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
        <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
      </ModalFooter>
    </Modal>
  );

  const getHeader = () => {
    return (
      <div className="action-container">
        <Link title="aggiungi sim" className="btn btn-primary p-button-icon-only" to={`add-sim`}>
          <i className="pi pi-plus mr-2"></i>Nuova SIM
        </Link>
        <Link
          title="importa sim"
          className="btn btn-primary p-button-icon-only"
          to={`import-simcards`}
        >
          <i className="pi pi-download mr-2"></i>Importazione SIM
        </Link>
      </div>
    );
  };

  const onRefresh = () => {
    forceRefresh();
    setGlobalFilter("");
  }

  const exportTable = () => {
    dtable.exportCSV();
  }

  return (
    <PageLayout title="Elenco SIM">
      <Row>
        <Col>
          <DataTable
            ref={el => {
              dtable = el;
            }}
            loading={loading}
            value={result}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            className="p-datatable-hoverable-rows p-datatable-customers"
            responsive
            paginator={true}
            autoLayout={false}
            first={0}
            rows={20}
            totalRecords={result.length}
            paginatorPosition="both"
            header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
            globalFilter={globalFilter}
            emptyMessage={() => (<div className="text-center">Nessuna SIM in tabella</div>)}
            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="Visualizzati {first} di {last} SIM su un totale di {totalRecords}"
          >
            <Column
              field="iccid"
              style={{ wordWrap: "break-word" }}
              header="ICCID"
              sortable
              filter
              filterMatchMode="contains"
              body={(rowData, column) => {
                return (
                  <Link
                    to={`simcards/${rowData._id}`}
                  >
                    {rowData.iccid}
                  </Link>
                );
              }}
            />
            <Column
              field="number"
              header="Telefono"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="imei"
              header="IMEI"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="attributes.carrier"
              header="Operatore"
              sortable
              filterElement={
                <DropdownFilterElement
                  field="attributes.carrier"
                  options={domains.carriers}
                  onChange={e => dtable.filter(e.value, e.field)}
                />
              }
              body={(row) => domains.carriers.find(el => el.value === row.attributes.carrier).label}
              filter
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="attributes.type"
              header="Tipo"
              sortable
              filterElement={
                <DropdownFilterElement
                  field="attributes.type"
                  options={domains.simTypes}
                  onChange={e => dtable.filter(e.value, e.field)}
                />
              }
              body={(row) => domains.simTypes.find(el => el.value === row.attributes.type).label}
              filter
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="status"
              header="Stato"
              sortable
              filter
              style={{ wordWrap: "break-word", textAlign: "center" }}
              filterElement={
                <DropdownFilterElement
                  field="status"
                  options={[
                    { label: "inserito", value: "inserito" },
                    { label: "associato", value: "associato" },
                    { label: "dismesso", value: "dismesso" }
                  ]}
                  onChange={e => dtable.filter(e.value, e.field)}
                />
              }
              body={(rowData, column) => {
                return (
                  <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                );
              }}
            />
            <Column
              field="actions"
              body={rowData => {
                return (
                  <div className="action-container">
                    <Link
                      title="Gestisci SIM"
                      className="btn btn-sm btn-primary p-button-icon-only mr-2"
                      to={`simcards/${rowData._id}`}
                    >
                      <i className="pi pi-pencil"></i>
                    </Link>
                    <Can
                      roles={[roles.ADMIN]}
                      yes={() => (
                        <Button
                          color="danger"
                          title="Elimina SIM"
                          onClick={() => setOpenModal(rowData)}
                          className="btn-sm p-button-icon-only"
                        >
                          <FontAwesomeIcon icon="trash-alt" />
                        </Button>
                      )}
                      no={() => null}
                    />
                  </div>
                );
              }}
              style={{ wordWrap: "break-word" }}
            />
          </DataTable>
        </Col>
      </Row>
      {modalSection()}
    </PageLayout>
  );
}
